import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import posthog from 'posthog-js';

import './scss/index.scss';
import './scss/login.scss';
import Color from '@tool/color';
import LoginSlick from './component/login-slick';
import LoginComp from './component/login-comp';
import {
  DButton, SmallButton, LoginButton, EButton,
  DInput, DCheckbox, LButton, FButton,
} from './styled';
import moForget, {
  changePhone, changeCaptcha, changePassword, changeCheckPwd,
  getCaptcha, modifyPassword, reset,
} from '@store/forget';
import moSkin from '@store/skin';
import { buildAuthPagePath } from '@lib/registration-attribution';

interface IProps {}
interface IState {}

const GButton = styled(EButton)(() => ({
  '&.text-15': {
    cursor: 'default',
    backgroundColor: Color.c999,
  },
}));

const Register = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    phone, captcha, password, checkPwd,
    phoneEmpty, captchaEmpty, passwordEmpty, checkPwdEmpty,
    qrText, qrClass, phoneErrorText, checkPwdErrorText,
  } = moForget;
  const { mainColor } = moSkin;

  useEffect(() => {
    document.title = '忘记密码';
    posthog.capture('忘记密码页浏览', {});
    reset();

    return () => {};
  }, []);

  // 跳转至登录页面
  const onLogin = () => { navi(buildAuthPagePath('/login', window.location.search)); };

  // 修改密码
  const onModify = () => {
    posthog.capture('忘记密码-修改密码按钮', {});
    modifyPassword(() => { navi(buildAuthPagePath('/login', window.location.search)); });
  };

  return (
    <section className="page-1101">
      <LoginSlick />
      <LoginComp>
        <section className="login-155">
          <section className="line-010">
            <strong>忘记密码</strong>
            <p>
              <FButton onClick={onLogin} style={{ color: mainColor }}>返回登录</FButton>
            </p>
          </section>
          <section className="line-012">
            <section className="line-115 line-116">
              <DInput value={phone} onChange={changePhone}
                placeholder="请输入手机号码" />
              <span className={[
                'err-11', phoneEmpty ? 'err-visible' : 'err-hidden',
              ].join(' ')}>{phoneErrorText}
              </span>
            </section>
            <section className="line-0011">
              <section className="line-115 line-117">
                <DInput value={captcha} onChange={changeCaptcha}
                  placeholder="请输入验证码" />
                <GButton onClick={getCaptcha}
                  className={[qrClass ? 'text-15' : ''].join(' ')}
                  style={{ backgroundColor: qrText === '获取验证码' ? mainColor : Color.c999 }}>{qrText}
                </GButton>
                <span className={[
                  'err-11', captchaEmpty ? 'err-visible' : 'err-hidden',
                ].join(' ')}>验证码不能为空
                </span>
              </section>
            </section>
            <p className="line-110011" />
            <section className="line-115 line-116">
              <DInput type="password" value={password} onChange={changePassword}
                placeholder="输入新密码" />
              <span className={[
                'err-11', passwordEmpty ? 'err-visible' : 'err-hidden',
              ].join(' ')}>密码不能为空
              </span>
            </section>
            <section className="line-115 line-117">
              <DInput type="password" value={checkPwd} onChange={changeCheckPwd}
                placeholder="确认密码" />
              <span className={[
                'err-11', checkPwdEmpty ? 'err-visible' : 'err-hidden',
              ].join(' ')}>{checkPwdErrorText}
              </span>
            </section>
          </section>
          <LoginButton onClick={onModify}
            style={{ backgroundColor: mainColor }}>修改密码
          </LoginButton>
        </section>
      </LoginComp>
    </section>
  );
};

export default observer(Register);
